import React, { useEffect } from "react";
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official';
import HC_exporting from 'highcharts/modules/exporting'
import HC_anotations from 'highcharts/modules/annotations'
import exportFromJSON from 'export-from-json';
import Theme from "highcharts/themes/grid-light";
require("highcharts/modules/export-data")(Highcharts);
HC_exporting(Highcharts)
HC_anotations(Highcharts)
Theme(Highcharts)

const NewGridLight:  any = (props:any) => {
    // console.log(props.allData);
    let buttons = Highcharts.getOptions().exporting?.buttons?.contextButton?.menuItems?.slice();
	buttons?.push("label");
    const {allData, exportExcel, labels, title, idChart, activeButton, colores} = props;
    const options = {
		chart: {
            type: 'area',
            zoomType: 'x',
            panning: true,
            backgroundColor: '#ffffff',
            panKey: 'shift',
            height:500,
            scrollablePlotArea: {
                minWidth: 700
            }
        },

		title: {
			text: title,
            style: {
				color: '#19355F',
				fontFamily: 'Montserrat-SemiBold'
            }
				
		},
        xAxis: {
            gridLineWidth: 0,
            categories: labels,
            minRange: 10,
        },
        legend: false,
    
        yAxis: {
            minorGridLineWidth: 0,
			gridLineWidth: 0,
            maxPadding:1,
            minPadding:2,
            tickInterval:10,
            labels:{
				format: '{value}%'
			},
            title: {
                text: null
            },
        },

        annotations: [{
            draggable: '',
            labelOptions: {
                verticalAlign: 'top',
                y: 15
                
                
            },
            labels: [{
                point: {
                    xAxis: 0,
                    yAxis: 0,
                    x: 5,
                    y: 36
                },
                text: 'Rechazo 5to retiro',
                
            },{
                point: {
                    xAxis: 0,
                    yAxis: 0,
                    x: 16,
                    y: 36
                },
                text: 'Entrega de propuesta de Constitución'
            },{
                point: {
                    xAxis: 0,
                    yAxis: 0,
                    x: 25,
                    y: 35
                },
                text: 'Triunfo del Rechazo / cambio de gabinete'
            },{
                point: {
                    xAxis: 0,
                    yAxis: 0,
                    x: 39,
                    y: 31
                },
                text: 'Nuevo acuerdo constitucional'
            },{
                point: {
                    xAxis: 0,
                    yAxis: 0,
                    x: 39,
                    y: 31
                },
                text: 'Nuevo acuerdo constitucional'
            },{
                point: {
                    xAxis: 0,
                    yAxis: 0,
                    x: 47,
                    y: 29
                },
                text: 'Incendios Forestales'
            },{
                point: {
                    xAxis: 0,
                    yAxis: 0,
                    x: 66,
                    y: 29
                },
                text: 'Caso Convenios'
            },
            {
                point: {
                    xAxis: 0,
                    yAxis: 0,
                    x: 75,
                    y: 29
                },
                text: 'Sistema Frontal'
            },{
                 point: {
                     xAxis: 0,
                     yAxis: 0,
                     x: 84,
                     y: 29
                 },
                text: 'Panamericanos'
            }
            //{
            //     point: {
            //         xAxis: 0,
            //         yAxis: 0,
            //         x: 60,
            //         y: 30
            //     },
            //     text: 'Elección Consejeros'
            // }
        ]
        }, {
            draggable: '',
            labels: [{
                point: {
                    xAxis: 0,
                    yAxis: 0,
                    x: 0,
                    y: 50
                },
                y:-20,
                text: 'Viaje Izkia Siches a La Araucanía',
            },{
                point: {
                    xAxis: 0,
                    yAxis: 0,
                    x: 11,
                    y: 44
                },
                y:-20,
                text: 'Cuenta Pública'
            },{
                point: {
                    xAxis: 0,
                    yAxis: 0,
                    x: 14,
                    y: 34
                },
                text: 'Gabinete Irina Karamanos'
            },{
                point: {
                    xAxis: 0,
                    yAxis: 0,
                    x: 34,
                    y: 35
                },
                text: 'Reforma de pensiones'
            },{
                point: {
                    xAxis: 0,
                    yAxis: 0,
                    x: 42,
                    y: 31
                },
                text: 'Indulto Presidencial'
            },{
                point: {
                    xAxis: 0,
                    yAxis: 0,
                    x: 51,
                    y: 33
                },
                text: 'Rechazo Reforma Tributaria'
            },{
                point: {
                    xAxis: 0,
                    yAxis: 0,
                    x: 57,
                    y: 29
                },
                text: 'Aprobación 40 horas'
            },{
                point: {
                    xAxis: 0,
                    yAxis: 0,
                    x: 63,
                    y: 41
                },
                text: '2º Cuenta Pública'
            },
            ,{
                point: {
                    xAxis: 0,
                    yAxis: 0,
                    x: 91,
                    y: 35
                },
               text: 'Plebiscito constitucional'
            },
            ,{
                point: {
                    xAxis: 0,
                    yAxis: 0,
                    x: 99,
                    y: 29
                },
               text: 'Fallecimiento Sebastián Piñera'
            },
            ,{
                point: {
                    xAxis: 0,
                    yAxis: 0,
                    x: 111,
                    y: 29
                },
               text: 'Caso Carabineros'
            },
            
        ]
        
        }],

        plotOptions: {
			series: {
                color:'purple',
				dataLabels: {
				align: 'right',
				enabled: true,
				inside: false,
				},
				grouping: true
			}
		},

        series:allData,
        
        tooltip: {
			shared: true,
			useHTML: true,
			headerFormat: '<table><tr><th colspan="2">{point.key}</th></tr>',
			pointFormat: '<tr><td>AP: </td>' +
				'<td style="text-align: right"><b>{point.y}%</b></td></tr>',
			footerFormat: '</table>',
			valueDecimals: 0
		},

		responsive: {  
			rules: [{  

			
			  condition: {  
				maxWidth: 1000
			  },  
			  chartOptions: {
				title: {		
					style: {
						color: '#19355F',
						fontFamily: 'Sans-Serif',
						fontSize: '12px'
					}
				},
                legend: {
                    align: 'center',
                    verticalAlign: 'bottom',
                    layout: 'horizontal',
					itemStyle: {
						color: '#19355F',
						fontFamily: 'Montserrat',
						fontSize: '8px',
					}
                },
				xAxis:{
					labels:{
						style:{
							fontSize: '8px',
						}
					}

				},
               
				subtitle: {
					style: {
						color: '#19355F',
						fontFamily: 'Montserrat',
						width: '80%',
						wordBreak: 'break-word',
						fontSize: '8px',

					}
					
				},
               
            }
			}]  
		  },
		  
		  lang: {
			downloadCSV: 'Descargar CSV',
			downloadJPEG: "Descargar JPEG",
			downloadPDF: "Descargar PDF",
			downloadPNG: "Descargar PNG",      
			downloadSVG: "Descargar SVG",
			downloadXLS: "Descargar XLS",
			exitFullscreen: "Salir de pantalla completa",
			viewFullscreen: "Ver Pantalla Completa",
			printChart: "Imprimir Gráfico"
		  },

		  exporting: {
			enabled: activeButton, 
			menuItemDefinitions: {
				// Custom definition
				label: {
					onclick: (event:any) => {
						console.log('clic boton custom');
						exportExcel({titulo: title, id: idChart});
					},
					text: 'Descargar XLSX'
				}
			},
			
			buttons: {
				contextButton: {
					menuItems: [

						"downloadPNG",
						"downloadJPEG",
                        "downloadPDF",
						"downloadSVG",
						"separator",
						"label"
					]
				}
			}
		},
		credits: {
			enabled: false
		}
	}

    return (
        <>
            <HighchartsReact highcharts={Highcharts} options={options}/>
        </>
    )
}

export default NewGridLight;

